import { gsap } from 'gsap'
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default {
  init() {
    console.log('impegno');

    new Swiper('.swiperCarosello', {
			modules: [Navigation],
			slideToClickedSlide: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			slidesPerView: 5,
			breakpoints: {
				1400: {
					slidesPerView: 5,
					spaceBetween: 20,
				},
				1200: {
					slidesPerView: 4.1,
					spaceBetween: 20,
				},
				920: {
					slidesPerView: 3.2,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 2.2,
					spaceBetween: 20,
				},
				570: {
					slidesPerView: 2.5,
					spaceBetween: 10,
				},
				320: {
					slidesPerView: 1.5,
					spaceBetween: 10,
				},
			},
			spaceBetween: 20,
			direction: 'horizontal',
			//loop: true,
	});

	new Swiper('.swiperCaroselloCert', {
		modules: [Navigation],
		slideToClickedSlide: false,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slidesPerView: 4,
		
		breakpoints: {
			1400: {
				slidesPerView: 4,
			},
			1024: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 2,
				
			},
			320: {
				slidesPerView: 1,
			},
		},
		spaceBetween: 20,
		direction: 'horizontal',
		//loop: true,
	});

	new Swiper('.swiperCaroselloRico', {
		modules: [Navigation],
		slideToClickedSlide: false,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slidesPerView: 2,
		breakpoints: {
			1024: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			320: {
				slidesPerView: 1,
				spaceBetween: 10,
			},
		},
		direction: 'horizontal',
		//loop: true,
	});

	

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
